<!-- 국가코드 선택용 공통 팝업 -->
<template>

  <v-container fluid>

    <v-row dense>
        <v-col md="10" sm="10" xs="10">
            <v-text-field height="43" outlined v-model="nationname" :label="$t('common_userinfo_label12')" dense disabled></v-text-field>
        </v-col>
        <v-col md="2" sm="2" xs="2" >
            <v-btn class="search_btn" elevation="0" outlined large @click="showpopup_com" >{{$t('common_select')}}</v-btn>
        </v-col>
    </v-row>   
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_com" @keydown.esc="close_com" max-width="1000px">
        <v-card class="dialog_round pa-2" style="height:800px">
          
          <v-row justify="space-between">
            <v-col align="center" cols="12" md="6" sm="6" xs="6">
              <span class="dialog_title">{{$t('nationdialog_col1')}}</span>
            </v-col>
            <v-col align="center" cols="12" md="6" sm="6" xs="6">
              <v-btn class="dialog_cancel_btn" rounded large @click="close_com">{{$t("common_close")}}</v-btn>
            </v-col>
          </v-row>
          <v-row dense justify="center">
            <v-col cols="11">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col md="10" sm="10" xs="10">
                  <v-text-field 
                    v-model="search"
                    dense single-line clearable
                    @keyup.enter="search_run_com" 
                    :placeholder="$t('common_search_holder')"
                    outlined height="43"
                    color="#808080"
                    class="ml-10"
                    hide-details
                    />
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-data-table
                    :headers="headers_com"
                    :items="itemList_com"
                    :items-per-page="9999"
                    v-model="select_com"
                    :no-data-text="$t('common_nodata')"
                    hide-default-footer
                    
                    class="datatablestyle ml-10 mr-10"
                    item-key="IDX"
                    :search="search"  
                    >
                    <template v-slot:header.NACODE>
                      <label class="cheader_normal" >{{$t("nationdialog_col1")}}</label>
                    </template>
                    <template v-slot:header.NAMEKOR>
                      <label class="cheader_normal" >{{$t("nationdialog_col2")}}</label>
                    </template>
                    <template v-slot:header.NAMEENG>
                      <label class="cheader_normal" >{{$t("nationdialog_col3")}}</label>
                    </template>
                    <template v-slot:item.NAMEKOR="{ item }">
                      <a @click="save_com(item)">{{item.NAMEKOR}}</a>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-btn class="dialog_cancel_btn" rounded large @click="close_com">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>     
    </v-row>
    
  </v-container>

</template>

<script>
    export default {
        
        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
          nationname: String,
        },

        data: ()=> ({
            dialog_com : false,
            load_flag : false,
            headers_com: [
                {text: '국가코드',  value: 'NACODE', sortable: true, align:'center'},
                {text: '국가명',    value: 'NAMEKOR', sortable: true, align:'center'},
                {text: '영문명',    value: 'NAMEENG', sortable: true, align:'center'}
            ],
            itemList_com: [],
            select_com:[],
            search: '',         //필터링용 검색어
        }),

        updated(){
          //console.log("event dialog update... " + this.dialog_com);
          if(this.dialog_com){
            if(!this.load_flag && this.itemList_com.length == 0){
              this.load_flag = false;
              this.loadpage_com();
            }
          }else{
            this.load_flag = false;
          }
        },

        methods: {

            loadpage_com(){

                this.$http.post(this.$host+'/api/NationCode',{
                },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
                .then((result)=>{
                    this.load_flag = true;
                    if(result.data.resultCode == 0){

                      //토큰 저장
                      if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                        this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                      }
                      if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                        this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                      }
                        const list = result.data.resultData;
                        this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                        list.forEach(element => {
                            this.itemList_com.push(element); 
                        });

                  }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                    }
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                    
                });

            },

            //다이얼로그 닫기
            close_com () {
                this.dialog_com = false
                this.select_com = [];
                this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            },

            //추가 저장
            save_com(select_item) {
              this.$emit('callback', select_item);
              //콜백 호출 후 닫아야함.
              this.dialog_com = false
              this.select_com = [];
              this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
            },      

            showpopup_com(){
                this.dialog_com = true;
                this.load_flag = false;
                this.loadpage_com();
            },


        }

    }
</script>

<style scoped>

</style>